import React from 'react';
import PropTypes from 'prop-types';

import { TOKEN_STORAGE_KEY } from '../../../../simple-connect';
import { DropdownLanguage } from '@weezevent/nacre';
import i18n, { aliases } from '../../../../i18n/i18n';
import { fetcher } from '@weezevent/weezjs-core';

import JWTParser from '../../../../helpers/jwt';
import Storage from '../../../../helpers/storage';

export default function Languages({ organization = null, displaySwitchLang = false, minimal = false }) {
    const { oAuthUrl } = window.weezConfig.connect;

    const onNewToken = React.useCallback(
        response => {
            // Store new token
            let token = response.access_token;
            fetcher.setToken(token);
            Storage.store(TOKEN_STORAGE_KEY, token);

            // Parse token to get the new local and change local
            let parsed_token = new JWTParser(token);
            let userLocale = parsed_token.payload?.data.locale;
            const accountsTokenLocale = userLocale.replace(/_/g, '-');
            const locale = aliases[accountsTokenLocale] ?? accountsTokenLocale;
            if (locale !== i18n.language) {
                i18n.changeLanguage(locale);
                fetcher.setLanguage(locale);
            }
        },
        [fetcher, aliases, i18n, Storage]
    );

    if (!organization || !displaySwitchLang) {
        return null;
    }

    return (
        <DropdownLanguage
            value={i18n.language.replace('-', '_')}
            items={['fr_FR', 'fr_CA', 'fr_CH', 'en_CA', 'en_US', 'en_GB', 'it_IT', 'es_ES', 'de_DE', 'de_CH', 'nl_NL']}
            onChange={value => {
                fetcher.post(`${oAuthUrl.replace('/auth', '')}/api/users/locale/switch/${value}`, {}).then(({ response }) => {
                    onNewToken(response);
                });
            }}
        />
    );
}

Languages.propTypes = {
    organization: PropTypes.object,
    displaySwitchLang: PropTypes.bool,
    firstEvent: PropTypes.bool
};
